import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Eye } from "lucide-react";
import { api, errorText } from "../../lib/api";
import { LeadDetail, STATUSES } from "./LeadDetail";

const TYPES = [["", "Toutes"], ["devis", "Devis"], ["rendez-vous", "Rendez-vous"], ["rappel", "Rappel"], ["domicile", "Domicile"], ["contact", "Contact"]];
const NOTIFY = { confirme: "confirmation", refuse: "refus", annule: "annulation" };
const rdvLabel = (l) => (l.type === "rendez-vous" && /^\d{2}:\d{2}$/.test(l.creneau || "") ? `${l.date_souhaitee.split("-").reverse().join("/")} ${l.creneau.replace(":", "h")}` : "—");

export function LeadsTab() {
  const [type, setType] = useState("");
  const [leads, setLeads] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/admin/leads", { params: type ? { type } : {} }).then((r) => setLeads(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(errorText(e)));
  useEffect(() => { load(); }, [type]); // eslint-disable-line react-hooks/exhaustive-deps
  const setStatus = async (l, status) => {
    const willNotify = l.type === "rendez-vous" && l.email && NOTIFY[status];
    if (willNotify && !window.confirm(`Un email de ${NOTIFY[status]} sera envoyé au client (${l.email}). Continuer ?`)) return;
    try {
      const r = await api.patch(`/admin/leads/${l.id}`, { status });
      toast.success(r.data?.notified ? "Statut mis à jour — client prévenu par email." : "Statut mis à jour.");
    } catch (e) {
      toast.error(errorText(e));
    }
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer cette demande ?")) return;
    await api.delete(`/admin/leads/${id}`);
    load();
  };
  return (
    <div>
      <div className="mb-4 flex flex-wrap gap-2">
        {TYPES.map(([v, l]) => <button key={v} onClick={() => setType(v)} className={`rounded-full px-4 py-1.5 text-sm font-semibold ${type === v ? "bg-ag-navy text-white" : "bg-white ring-1 ring-slate-200"}`} data-testid={`leads-filter-${v || "all"}`}>{l}</button>)}
      </div>
      <div className="overflow-x-auto rounded-2xl bg-white ring-1 ring-slate-200">
        <table className="w-full text-left text-sm" data-testid="leads-table">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr><th className="p-3">Date</th><th className="p-3">Type</th><th className="p-3">Nom</th><th className="p-3">RDV</th><th className="p-3">Téléphone</th><th className="p-3">Service</th><th className="p-3">Email</th><th className="p-3">Statut</th><th className="p-3" /></tr></thead>
          <tbody>
            {leads.length === 0 && <tr><td colSpan={9} className="p-6 text-center text-slate-500">Aucune demande.</td></tr>}
            {leads.map((l) => (
              <tr key={l.id} className="border-t border-slate-100" data-testid={`lead-row-${l.id}`}>
                <td className="whitespace-nowrap p-3">{new Date(l.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</td>
                <td className="p-3"><span className="rounded-full bg-ag-mist px-2 py-0.5 text-xs font-semibold text-ag-navy">{l.type}</span></td>
                <td className="p-3 font-semibold">{l.nom} {l.prenom || ""}</td>
                <td className="whitespace-nowrap p-3 font-mono text-xs" data-testid={`lead-rdv-${l.id}`}>{rdvLabel(l)}</td>
                <td className="whitespace-nowrap p-3"><a href={`tel:${l.telephone}`} className="text-ag-blue">{l.telephone}</a></td>
                <td className="p-3">{l.service || "—"}{l.photo_count ? ` · ${l.photo_count} photo(s)` : ""}</td>
                <td className="whitespace-nowrap p-3 text-xs" data-testid={`lead-email-status-${l.id}`}>{l.email_status?.owner === "sent" ? <span className="text-emerald-700">Envoyé</span> : l.email_status?.owner === "failed" ? <span className="text-red-600">Échec</span> : <span className="text-slate-400">—</span>}</td>
                <td className="p-3"><select value={l.status} onChange={(e) => setStatus(l, e.target.value)} className="rounded-lg border border-slate-200 px-2 py-1" data-testid={`lead-status-${l.id}`}>{STATUSES.map(([v, t]) => <option key={v} value={v}>{t}</option>)}</select></td>
                <td className="whitespace-nowrap p-3">
                  <button onClick={() => setOpen(l.id)} className="mr-2 text-slate-500 hover:text-ag-blue" aria-label="Voir" data-testid={`lead-view-${l.id}`}><Eye className="h-4 w-4" /></button>
                  <button onClick={() => del(l.id)} className="text-slate-500 hover:text-red-600" aria-label="Supprimer" data-testid={`lead-delete-${l.id}`}><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <LeadDetail id={open} onClose={() => setOpen(null)} onChanged={load} />
    </div>
  );
}
